<template lang="pug">
  #other-user-group-type-list(v-cloak)
    .box
      .box-header.register-header
        .title
          span 施設関係者グループ種類情報一覧
        .clearfix
          .float-right
            button.btn.group-type-list-btn(@click="gotoOtherUserGroupTypeEdit()") 修正
            button.btn.back-btn(@click="gotoOtherUserGroupList()") 戻る
      .box-body
        .other-user-group-type-table-component
          // テーブル
          b-table(
            :items="otherUserGroupTypeItems"
            :fields="otherUserGroupTypeFields"
            :busy="isLoading"
            sticky-header
            no-border-collapse
            table-class="basic-table"
            show-empty
          )
            // ローディング
            template(#table-busy)
              .text-center.table-loading-message
                b-spinner.spinner
                span.message.align-self-center 読込み中...
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";

/**
 * 施設関係者グループ一覧画面コンポーネント
 */
@Component({})
export default class OtherUserGroupTypeList extends Vue {
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;

  /** 施設関係者グループ種類の列 */
  otherUserGroupTypeFields: Array<OtherUserGroupTypeTableField> = [];
  /** 施設関係者グループ種類の行 */
  otherUserGroupTypeItems: Array<OtherUserGroupTypeTableItem> = [];
  /** 読込み中か否か */
  isLoading: boolean = true;

  /**
   * vue lifecycle mounted
   *
   * 画面表示情報の作成を行う
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    const otherUserGroupTypeFields: Array<OtherUserGroupTypeTableField> = this.createOtherUserGroupTypeFields();
    this.otherUserGroupTypeFields = otherUserGroupTypeFields;

    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypeItems: Array<OtherUserGroupTypeTableItem> = this.createOtherUserGroupTypeItems(otherUserGroupTypes);
    this.otherUserGroupTypeItems = otherUserGroupTypeItems;

    this.isLoading = false;

    return;
  }

  /**
   * ### 列名の作成
   */
  public createOtherUserGroupTypeFields(): Array<OtherUserGroupTypeTableField> {
    let fields: Array<OtherUserGroupTypeTableField> = [];

    fields.push({ key: "id", label: "番号", sortable: false, sortDirection: "desc", class: "id" });
    fields.push({ key: "name", label: "種類名", sortable: false, sortDirection: "desc", class: "name" });
    fields.push({ key: "description", label: "説明", sortable: false, sortDirection: "desc", class: "description" });

    return fields;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 行の作成
   */
  public createOtherUserGroupTypeItems(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Array<OtherUserGroupTypeTableItem> {
    let items: Array<OtherUserGroupTypeTableItem> = [];

    for (const type of otherUserGroupTypes) {
      items.push({
        id: type.id,
        name: type.name,
        description: type.description
      });
    }

    return items;
  }

  /**
   * ### 施設関係者グループ種類編集画面へ遷移する
   */
  public gotoOtherUserGroupTypeEdit(): void {
    this.$router.push(PcUrl.OtherUserGroupTypeEdit);
    return;
  }

  /**
   * ### 施設関係者グループ一覧画面へ遷移する
   */
  public gotoOtherUserGroupList(): void {
    this.$router.push(PcUrl.OtherUserGroupList);
    return;
  }
}

/** テーブルの列名の情報 */
export interface OtherUserGroupTypeTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OtherUserGroupTypeTableItem {
  id: number;
  name: string;
  description: string;
}
</script>

<style lang="scss" scoped>
// 親要素からネストしてスタイルを指定する
#other-user-group-type-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .group-type-list-btn {
    width: 80px;
  }

  .back-btn {
    margin-left: 12px;
    width: 80px;
  }
}
</style>
